import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../assetManifest";
import { CONSTANTS } from "../data";
import { Howl } from "howler";

const menuSelectSound = new Howl({
  src: [ASSETS.sfx.menuSelect.path],
  volume: 0.5,
});

export function MainMenu({ onMenuClick }: { onMenuClick: (id: string) => void }) {
  return (
    <div
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${ASSETS.backgrounds.mainMenu.path})` }}
    >
      <div className="flex flex-col items-center justify-center h-full bg-black bg-opacity-50 text-white p-4">
        <motion.img
          src={ASSETS.sprites.title_logo.path}
          alt={CONSTANTS.GAME_TITLE}
          className="mb-4"
          style={{ 
            filter: 'drop-shadow(4px 4px 0px #000000)',
            maxWidth: CONSTANTS.TITLE_LOGO_MAX_WIDTH,
            height: 'auto'
          }}
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 100, delay: 0.2 }}
        />
        <motion.div
          className="flex flex-col items-center space-y-5 mt-12"
          initial="hidden"
          animate="visible"
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.2,
                delayChildren: 0.5,
              },
            },
          }}
        >
          {CONSTANTS.MENU_ITEMS.map((item) => (
            <motion.button
              key={item.id}
              className="text-2xl md:text-3xl px-8 py-3 cursor-pointer hover:text-yellow-400 focus:outline-none"
              style={{ textShadow: '3px 3px #000000' }}
              onMouseEnter={() => menuSelectSound.play()}
              onClick={() => onMenuClick(item.id)}
              variants={{
                hidden: { opacity: 0, x: -100 },
                visible: { opacity: 1, x: 0 },
              }}
              whileHover={{ scale: 1.1, textShadow: '4px 4px #c79500' }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: 'spring', stiffness: 400, damping: 17 }}
            >
              {item.label}
            </motion.button>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
